<template>
  <basic-container>
    <avue-crud
            :option="option"
            :data="data"
            :page.sync="page"
            :search.sync="search"
            ref="crud"
            @row-del="rowDel"
            v-model="form"
            :permission="permissionList"
            @row-update="rowUpdate"
            @row-save="rowSave"
            :before-open="beforeOpen"
            @search-change="searchChange"
            @search-reset="searchReset"
            @refresh-change="refreshChange"
            @selection-change="selectionChange"
            @current-change="currentChange"
            @size-change="sizeChange"
            @on-load="onLoad">
      <template slot="menuLeft">
        <el-button
                type="danger"
                size="small"
                icon="el-icon-delete"
                v-if="permission.sys_tenant_delete"
                @click="handleDelete">删 除
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import mixin from '@/util/mixin'

export default {
  mixins: [mixin],
  data () {
    return {
      module: 'sys/tenant',
      form: {},
      search: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '租户编号',
            prop: 'id',
            rules: [{
              required: true,
              message: '请输入租户编号'
            }]
          },
          {
            label: '二级域名',
            prop: 'serverName',
            rules: [{
              required: true,
              message: '请输入二级域名'
            }]
          },
          {
            label: '租户名称',
            prop: 'tenantName',
            rules: [{
              required: true,
              message: '请输入租户名称'
            }]
          },
          {
            label: '逻辑删除',
            prop: 'deleted',
            rules: [{
              required: true,
              message: '请输入逻辑删除'
            }]
          }
        ]
      },
      data: []
    }
  },
  computed: {
    permissionList () {
      return {
        addBtn: this.permission.sys_tenant_add,
        viewBtn: this.permission.sys_tenant_view,
        delBtn: this.permission.sys_tenant_delete,
        editBtn: this.permission.sys_tenant_edit
      }
    }
  },
  methods: {
  }
}
</script>
